import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { DialogService } from 'primeng/dynamicdialog';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ViewReasonModalComponent } from 'src/app/cxone/admin/shared/view-reason-modal/view-reason-modal.component';

@Component({
    selector: 'cv-action-cell',
    templateUrl: './action-cell.component.html',
    styleUrls: ['./action-cell.component.scss'],
    providers: [DialogService]
})
export class ActionCellComponent implements ICellRendererAngularComp {

    public params: any;
    public viewButton: string;

    constructor(
        private dialogService: DialogService,
        private cvLocalizationService: CVLocalizationService
    ) {
        this.viewButton = this.getLocalizationString("View", "View");
    }

    agInit(params): void {
        this.params = params;
    }

    refresh(params: any): boolean {
        this.params = params;
        return true;
    }

    public viewReason() {
        this.dialogService.open(ViewReasonModalComponent, {
            width: '796px',
            height: '589px',
            styleClass: 'cx-one-ui',
            data: {
                title: this.getLocalizationString("Reason", "Reason") + ' - ' + this.params?.data?.Title,
                cancelLabel: this.getLocalizationString("Close", "Close"),
                content: this.params?.data?.Reason
            }
        });
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        return this.cvLocalizationService.getCachedText("Failed_Reports", key, defaultValue);
    }
}
